export enum SubscriptionTypeEnum {
    MAIL = 'mail',
}
